export function formatPhoneNumber(num: any) {
  if (num.length <= 7) return num // No formatting if too short

  return num.replace(/^(\d{3})(\d+)(\d{4})$/, (match: any, firstGroup: any, middle: any, lastFour: any) => {
    return '+1' + '-' + firstGroup + '-' + middle.replace(/(\d{3})/g, '$1-').replace(/-$/, '') + '-' + lastFour
  })
}
